import { createContext, useContext } from 'react';

import type { AppRole, UserResponse } from '../api/types';

export interface AuthContextValue {
  user: UserResponse | null;
  /** true, пока восстанавливаем сессию из сохранённых токенов. */
  isRestoring: boolean;
  isAuthenticated: boolean;
  hasRole: (role: AppRole) => boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  setUser: (user: UserResponse) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (value === null) {
    throw new Error('useAuth должен вызываться внутри AuthProvider.');
  }
  return value;
}
